import React, {useState, useEffect} from "react";
import {BrowserRouter, Link, Routes, Route} from "react-router-dom";
import TextBalancer from "react-wrap-balancer";

import "./App.css";
import Blogs from "./blogs";
import AiBookmarks from "./aibookmarks";
import AppDevelopment from "./appDevelopment";
import DevelopmentArticles from "./development_Articles";
import GithubRepos from "./github_repos";
import WebDevelopment from "./web_development";
import NoCodeLowCode from "./nocode_lowcode";
import SoftwareDevelopment from "./software_development";
import WorkingAndFreelance from "./working_and_freelance";
import LearningPlatforms from "./learning_platforms";
import ConsoleTechnologies from "./console_technologies";
import Design from "./design";
import SearchResults from './SearchResults';
import MobileWelcomeMessage from "./MobileWelcomeMessage";
import CyberSecurity from "./cyber_security";
import CloudComputing from "./cloud_computing";
import Blockchain from "./blockchain";
import GameDevelopment from "./game_development";
import Community from "./community";
import NoName2022 from "./no_name_2022";
import NoName2021 from "./no_name_2021";
import NoName2020 from "./no_name_2020";
import NoName2022_2 from "./no_name_2022-2";
import NoName2021_2 from "./no_name_2021-2";
import NoName2021_3 from "./no_name_2021-3";
import NoName2021_4 from "./no_name_2021-4";
import NoName2021_5 from "./no_name_2021-5";
import NoName2021_6 from "./no_name_2021-6";
import NoName2020_2 from "./no_name_2020-2";
import Roadmap from "./Roadmap";

const WelcomeMessage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="card bg-base-100 shadow-2xl m-4 rounded-lg overflow-hidden">
            <div className="card-body p-6">
                <TextBalancer>
                    <h2 className="card-title text-3xl font-bold text-base-content mb-4">
                        Welcome to Raindrop Explorer!
                    </h2>
                    <p className="text-xl text-base-content">
                        The dedicated space for sharing and exploring curated content on web
                        and mobile app development, software development, and AI. Created by
                        Othman Adi, a seasoned software developer with a passion for
                        mentoring and educating.
                    </p>
                    <p className="text-xl text-base-content my-4">
                        Explore a wealth of knowledge through the blogs and bookmarks I've
                        collected. Discover the latest and best articles, tools, and
                        findings in AI directly from my Raindrop bookmark manager. For a
                        deeper insight into this project and its development, check out my
                        article{" "}
                        <a
                            href="https://dev.to/othmanadi/building-a-comprehensive-learning-path-dashboard-with-nextjs-and-raindrop-api-dem"
                            className="link link-primary underline"
                        >
                            here
                        </a>.
                    </p>
                    <p className="text-xl text-base-content">
                        Don't forget to click the 'Bookmarks' button in the navbar or the
                        button below to start exploring the best resources today!
                    </p>

                    <div className="card-actions justify-center p-6">
                        <Link
                            to="/ai-bookmarks"
                            className="btn btn-primary hover:text-white"
                        >
                            Explore AI Bookmarks
                        </Link>
                    </div>

                    <div className="mt-6 flex justify-center">
                        <a
                            href="https://www.linkedin.com/in/codingwithadi/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-circle btn-outline btn-primary mr-4"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="fill-current"
                            >
                                <path
                                    d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                            </svg>
                        </a>
                        <a
                            href="https://github.com/OthmanAdi"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-circle btn-outline btn-primary"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="fill-current"
                            >
                                <path
                                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                            </svg>
                        </a>
                    </div>
                </TextBalancer>
            </div>
        </div>
    );
};

function App() {
    const [searchQuery, setSearchQuery] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [currentBookmark, setCurrentBookmark] = useState("Bookmarks"); // Default text

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleBookmarkClick = (itemName, itemPath) => {
        setIsDropdownOpen(false); // Close the dropdown when a link is clicked
        setActiveItem(itemName);
        setCurrentBookmark(itemName); // Update the current bookmark name
    };

    const [visibleBookmarks, setVisibleBookmarks] = useState([]);
    const [isMoreBookmarksVisible, setIsMoreBookmarksVisible] = useState(false);

    const allBookmarks = [
        {name: 'AI Bookmarks', path: '/ai-bookmarks'},
        {name: 'App Development', path: '/appDevelopment'},
        {name: 'Development Articles', path: '/development_articles'},
        {name: 'Github Repositories', path: '/github_repos'},
        {name: 'Web Development', path: '/web_development'},
        {name: 'No Code & Low Code', path: '/nocode_lowcode'},
        {name: 'Software Development', path: '/software_development'},
        {name: 'Working and Freelance', path: '/working_and_freelance'},
        {name: 'Learning Platforms', path: '/learning_platforms'},
        {name: 'Console Technologies', path: '/console_technologies'},
        {name: 'Design', path: '/design'},
        {name: 'Cyber Security', path: '/cyber_security'},
        {name: 'Cloud Computing', path: '/cloud_computing'},
        {name: 'Blockchain', path: '/blockchain'},
        {name: 'Game Development', path: '/game_development'},
        {name: 'Community & Networking', path: '/community'},
        {name: 'No Name 2022 pt.1', path: '/no_name_2022'},
        {name: 'No Name 2022 pt.2', path: '/no_name_2022-2'},
        {name: 'No Name 2021 pt.1', path: '/no_name_2021'},
        {name: 'No Name 2021 pt.2', path: '/no_name_2021-2'},
        {name: 'No Name 2021 pt.3', path: '/no_name_2021-3'},
        {name: 'No Name 2021 pt.4', path: '/no_name_2021-4'},
        {name: 'No Name 2021 pt.5', path: '/no_name_2021-5'},
        {name: 'No Name 2021 pt.6', path: '/no_name_2021-6'},
        {name: 'No Name 2020 pt.1', path: '/no_name_2020'},
        {name: 'No Name 2020 pt.2', path: '/no_name_2020-2'},
    ];

    const initialBookmarks = allBookmarks.slice(0, 11); // Bookmarks up to 'Design'
    const additionalBookmarks = allBookmarks.slice(11);

    useEffect(() => {
        setVisibleBookmarks(initialBookmarks);
    }, []);

    const handleDiscoverMore = () => {
        setIsMoreBookmarksVisible(true);
        setVisibleBookmarks(allBookmarks);
    };

    const [isBusinessTheme, setIsBusinessTheme] = useState(false);

    useEffect(() => {
        const root = window.document.documentElement;
        if (isBusinessTheme) {
            root.setAttribute('data-theme', 'business');
        } else {
            root.setAttribute('data-theme', 'corporate');
        }
    }, [isBusinessTheme]);

    const toggleTheme = () => {
        setIsBusinessTheme(!isBusinessTheme);
    };

    const [darkTheme, setDarkTheme] = useState(false);

    const toggleNavBarTheme = () => {
        setDarkTheme(!darkTheme);
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1025);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNavigate = () => {
        window.location.href = '/roadmap'; // This will cause the browser to navigate to the new URL
    };

// Define the routes as an array of objects
//     const AppRoutes = () => {
//         return useRoutes([
//             { path: "/", element: isMobile ? <MobileWelcomeMessage /> : <WelcomeMessage /> }, {
//             path: "/blogs",
//             element: <Blogs/>
//         }, {path: "/ai-bookmarks", element: <AiBookmarks/>}, {
//             path: "/AppDevelopment",
//             element: <AppDevelopment/>
//         }, {path: "/development_articles", element: <DevelopmentArticles/>}, {
//             path: "/github_repos",
//             element: <GithubRepos/>
//         }, {path: "/web_development", element: <WebDevelopment/>}, {
//             path: "/nocode_lowcode",
//             element: <NoCodeLowCode/>
//         }, {path: "/software_development", element: <SoftwareDevelopment/>}, {
//             path: "/working_and_freelance",
//             element: <WorkingAndFreelance/>
//         }, {path: "/learning_platforms", element: <LearningPlatforms/>}, {
//             path: "/console_technologies",
//             element: <ConsoleTechnologies/>
//         }, {path: "/design", element: <Design/>},
//             {path: "/search-results", element: <SearchResults/>},
//         ]);
//     };

    return (<BrowserRouter>
            <div className="App flex flex-col min-h-screen bg-base-200">
                <header
                    className={`${darkTheme ? 'bg-black' : 'bg-slate-200'} text-white p-4 fixed top-0 w-full z-10 shadow-lg`}>
                    <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center">
                        <h1 className="text-2xl font-bold mb-4 sm:mb-0">
                            <Link to="/" className={`btn ${darkTheme ? 'btn-ghost' : ''} flex items-center`}
                                  onClick={() => {
                                      setCurrentBookmark("Bookmarks");
                                      setActiveItem(null);
                                  }}>
                                <span className="text-lg mr-2">🌧️</span> Raindrop Explorer
                            </Link>
                        </h1>
                        <nav className="flex-1 text-center flex justify-between items-center">

                            <div className="dropdown dropdown-smaller responsive-dropdown">
                                <div tabIndex={0} role="button" className="m-1 btn">Blogs & Posts</div>
                                <ul tabIndex={0}
                                    className="dropdown-content dropdown-content-smaller z-[1] menu p-2 shadow bg-base-100 rounded-box gap-3 w-auto">

                                    <label className="input input-bordered flex items-center gap-2 w-52">
                                        <input
                                            type="text"
                                            className="grow"
                                            placeholder="Search Bookmarks"
                                            style={{color: '#027fbf'}}
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && searchQuery.trim()) {
                                                    // Navigate to the search results page when Enter is pressed
                                                    window.location.href = `/search-results?query=${encodeURIComponent(searchQuery)}`;
                                                    setSearchQuery('');  // Clear the input field after search
                                                }
                                            }}
                                        />
                                    </label>

                                    <button className="btn btn-success w-52" onClick={handleNavigate}>
                                        <div className="indicator">
                                            <span
                                                className="indicator-item badge badge-primary roadmapIndicator-offset">New!</span>
                                            <p className="text-red-300">Roadmap</p>
                                        </div>
                                    </button>

                                    <button className="btn btn-outline btn-secondary w-52">
                                        <p className="text-red-300">Blogs</p> <span
                                        className="badge badge-secondary">Coming Soon</span>
                                    </button>

                                    <button className="btn btn-outline btn-secondary w-52">
                                        <p className="text-red-300">LinkedIn Posts</p> <span
                                        className="badge badge-secondary">Coming Soon</span>
                                    </button>

                                    <li>
                                        <a
                                            href="https://www.linkedin.com/in/codingwithadi/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`btn ${darkTheme ? 'btn-ghost' : 'btn'} fill-current`}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                className="fill-current"
                                            >
                                                <path
                                                    d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://github.com/othmanadi"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`btn ${darkTheme ? 'btn-ghost' : 'btn'} fill-current`}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                className="fill-current"
                                            >
                                                <path
                                                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="join">
                                <ul className="menu menu-horizontal p-0 join-item">
                                    <li tabIndex="0" className="dropdown dropdown-hover">
                                        <button
                                            className={`btn ${darkTheme ? 'btn-ghost' : ''} me-4 ${activeItem ? 'bg-blue-500 text-white' : 'text-base-content'}`}
                                            onClick={toggleDropdown}>
                                            {currentBookmark}
                                        </button>
                                        {isDropdownOpen && (
                                            <ul className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 text-base-content"
                                                style={{
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    maxHeight: "60vh",
                                                    overflowY: "scroll",
                                                    scrollbarWidth: "none",
                                                    msOverflowStyle: "none",
                                                    display: "block" // Ensures that the dropdown is treated as a block-level element with vertical layout
                                                }}>
                                                {visibleBookmarks.map(item => (
                                                    <li key={item.name}
                                                        style={{display: "block"}}> {/* This ensures each item is a block, preventing horizontal alignment */}
                                                        <Link
                                                            to={item.path}
                                                            className={`text-base-content ${activeItem === item.name ? 'bg-blue-500' : ''}`}
                                                            onClick={() => handleBookmarkClick(item.name)}>
                                                            {item.name}
                                                        </Link>
                                                    </li>
                                                ))}
                                                {!isMoreBookmarksVisible && (
                                                    <li className="w-full" style={{display: "block"}}>
                                                        <button
                                                            className="btn btn-outline btn-primary w-full mt-2"
                                                            onClick={handleDiscoverMore}>
                                                            Discover More!
                                                        </button>
                                                    </li>
                                                )}
                                            </ul>
                                        )}
                                    </li>


                                    <li className="join-item">
                                        <button className="btn btn-success w-20 me-2 hide-on-mobile"
                                                onClick={handleNavigate}>
                                            <div className="indicator">
                                        <span
                                            className="indicator-item badge badge-primary roadmapIndicator-offset">New!</span>
                                                <p className="text-red-300">Roadmap 🛣️</p>
                                            </div>
                                        </button>
                                    </li>

                                    <li className="join-item">
                                        <button className="btn btn-outline btn-secondary hide-on-mobile">
                                            <p className="text-red-300">Blogs</p> <span
                                            className="badge badge-secondary">Coming Soon</span>
                                        </button>
                                    </li>

                                    <li className="join-item">
                                        <button
                                            className="btn btn-outline btn-secondary ml-2 me-2 hide-on-mobile">
                                            <p className="text-red-300">LinkedIn Posts</p> <span
                                            className="badge badge-secondary">Coming Soon</span>
                                        </button>
                                    </li>

                                    <li className="join-item">
                                        <label
                                            className="input input-bordered flex items-center gap-2 me-4 hide-on-mobile">
                                            <input
                                                type="text"
                                                className="grow"
                                                placeholder="Search Bookmarks"
                                                style={{color: '#027fbf'}}  // Ensure text color is black
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && searchQuery.trim()) {
                                                        // Navigate to the search results page when Enter is pressed
                                                        window.location.href = `/search-results?query=${encodeURIComponent(searchQuery)}`;
                                                        setSearchQuery('');  // Clear the input field after search
                                                    }
                                                }}
                                            />
                                        </label>
                                    </li>

                                    <li className="join-item">
                                        <a
                                            href="https://www.linkedin.com/in/codingwithadi/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`btn ${darkTheme ? 'btn-ghost' : ''} hide-on-mobile me-1`}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                className="fill-current"
                                            >
                                                <path
                                                    d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                                            </svg>
                                        </a>
                                    </li>

                                    <li className="join-item">
                                        <a
                                            href="https://github.com/othmanadi"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`btn ${darkTheme ? 'btn-ghost' : ''} hide-on-mobile`}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                className="fill-current"
                                            >
                                                <path
                                                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="flex items-center mr-4">
                                <label className="swap swap-rotate">
                                    {/* this hidden checkbox controls the state */}
                                    <input type="checkbox" onChange={toggleTheme} checked={isBusinessTheme}/>

                                    {/* sun icon */}
                                    <svg className="swap-on fill-current w-10 h-10"
                                         xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 24 24"
                                         onClick={toggleNavBarTheme}>
                                        <path
                                            d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"/>
                                    </svg>

                                    {/* moon icon */}
                                    <svg className="swap-off fill-current w-10 h-10"
                                         xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 24 24"
                                         onClick={toggleNavBarTheme}>
                                        <path
                                            d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"/>
                                    </svg>
                                </label>
                            </div>
                        </nav>
                    </div>
                </header>

                {/* Main Section */}
                <main className="flex-grow px-4 main-content">
                    <Routes>
                        <Route path="/" element={isMobile ? <MobileWelcomeMessage/> : <WelcomeMessage/>}/>
                        <Route path="/blogs" element={<Blogs/>}/>
                        <Route path="/ai-bookmarks" element={<AiBookmarks/>}/>
                        <Route path="/AppDevelopment" element={<AppDevelopment/>}/>
                        <Route path="/development_articles" element={<DevelopmentArticles/>}/>
                        <Route path="/github_repos" element={<GithubRepos/>}/>
                        <Route path="/web_development" element={<WebDevelopment/>}/>
                        <Route path="/nocode_lowcode" element={<NoCodeLowCode/>}/>
                        <Route path="/software_development" element={<SoftwareDevelopment/>}/>
                        <Route path="/working_and_freelance" element={<WorkingAndFreelance/>}/>
                        <Route path="/learning_platforms" element={<LearningPlatforms/>}/>
                        <Route path="/console_technologies" element={<ConsoleTechnologies/>}/>
                        <Route path="/design" element={<Design/>}/>
                        <Route path="/search-results" element={<SearchResults/>}/>
                        <Route path="/roadmap" element={<Roadmap/>}/>
                        <Route path="/cyber_security" element={<CyberSecurity/>}/>
                        <Route path="/cloud_computing" element={<CloudComputing/>}/>
                        <Route path="/blockchain" element={<Blockchain/>}/>
                        <Route path="/game_development" element={<GameDevelopment/>}/>
                        <Route path="/community" element={<Community/>}/>
                        <Route path="/no_name_2022" element={<NoName2022/>}/>
                        <Route path="/no_name_2022-2" element={<NoName2022_2/>}/>
                        <Route path="/no_name_2021" element={<NoName2021/>}/>
                        <Route path="/no_name_2021-2" element={<NoName2021_2/>}/>
                        <Route path="/no_name_2021-3" element={<NoName2021_3/>}/>
                        <Route path="/no_name_2021-4" element={<NoName2021_4/>}/>
                        <Route path="/no_name_2021-5" element={<NoName2021_5/>}/>
                        <Route path="/no_name_2021-6" element={<NoName2021_6/>}/>
                        <Route path="/no_name_2020" element={<NoName2020/>}/>
                        <Route path="/no_name_2020-2" element={<NoName2020_2/>}/>
                    </Routes>
                </main>

                {/* Footer */}
                <footer
                    className={`${darkTheme ? 'bg-black text-white' : 'bg-slate-200 text-base-content'} footer footer-center p-1 flex flex-row justify-center items-center h-auto min-h-[100px] opacity-95 center-content-footer`}>
                    <div className="hidden lg:block center-content">
                        <p className="font-bold text-lg">
                            Raindrop Explorer
                            <span className="text-lg ml-2">🌧️</span>
                        </p>
                    </div>
                    <div className="hidden lg:block">
                        <p className="text-sm rounded-lg bg-white text-black p-2 responsive-text">
                            Explore curated content on AI, web and mobile app development,
                            software development, and <span className="highlighted-text">much more</span>.
                        </p>
                    </div>

                    <div>
                        <p className="font-bold text-lg">
                            Made by
                            <a
                                href="https://othmanadi.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="creator-name px-1"
                            >
                                Othman Adi
                            </a>
                        </p>

                        <div className="responsive-text">
                            <p>Contact me:</p>
                            <a
                                href="https://othmanadi.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link"
                            >
                                Website
                            </a>
                            <a
                                href="https://codingwithadi-b876e.web.app/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link"
                            >
                                Portfolio
                            </a>
                            <p>
                                Email:
                                <a href="mailto:info@othmanadi.com" className="email">
                                    info@othmanadi.com
                                </a>
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </BrowserRouter>
    );
}

export default App;
